var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23V24H32V23C32 22.4477 32.4477 22 33 22C33.5523 22 34 22.4477 34 23V31C34 33.2091 32.2091 35 30 35H18C15.7909 35 14 33.2091 14 31V23C14 22.4477 14.4477 22 15 22C15.5523 22 16 22.4477 16 23ZM16 24V31C16 32.1046 16.8954 33 18 33H30C31.1046 33 32 32.1046 32 31V24H16ZM24 13C24.2978 13 24.5652 13.1302 24.7484 13.3367L27.7066 16.2924C28.0974 16.6827 28.0979 17.3158 27.7076 17.7066C27.3173 18.0974 26.6842 18.0979 26.2934 17.7076L25 16.416V26C25 26.5523 24.5523 27 24 27C23.4477 27 23 26.5523 23 26V16.415L21.7066 17.7076C21.3459 18.0678 20.7786 18.0952 20.3866 17.7899L20.2924 17.7066C19.9021 17.3158 19.9026 16.6827 20.2934 16.2924L23.2516 13.3367C23.4348 13.1302 23.7022 13 24 13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ffdcf573.svg";
export { ForwardRef as ReactComponent };